"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Identifiers = void 0;
var Identifiers;
(function (Identifiers) {
    var ContentItemIdentifierEnum;
    (function (ContentItemIdentifierEnum) {
        ContentItemIdentifierEnum["ExternalId"] = "externalId";
        ContentItemIdentifierEnum["InternalId"] = "internalId";
        ContentItemIdentifierEnum["Codename"] = "codename";
    })(ContentItemIdentifierEnum = Identifiers.ContentItemIdentifierEnum || (Identifiers.ContentItemIdentifierEnum = {}));
    var ContentTypeIdentifierEnum;
    (function (ContentTypeIdentifierEnum) {
        ContentTypeIdentifierEnum["ExternalId"] = "externalId";
        ContentTypeIdentifierEnum["InternalId"] = "internalId";
        ContentTypeIdentifierEnum["Codename"] = "codename";
    })(ContentTypeIdentifierEnum = Identifiers.ContentTypeIdentifierEnum || (Identifiers.ContentTypeIdentifierEnum = {}));
    var LanguageIdentifierEnum;
    (function (LanguageIdentifierEnum) {
        LanguageIdentifierEnum["InternalId"] = "internalId";
        LanguageIdentifierEnum["Codename"] = "codename";
        LanguageIdentifierEnum["ExternalId"] = "externalId";
    })(LanguageIdentifierEnum = Identifiers.LanguageIdentifierEnum || (Identifiers.LanguageIdentifierEnum = {}));
    var WorkflowIdentifierEnum;
    (function (WorkflowIdentifierEnum) {
        WorkflowIdentifierEnum["Id"] = "id";
        WorkflowIdentifierEnum["Codename"] = "codename";
    })(WorkflowIdentifierEnum = Identifiers.WorkflowIdentifierEnum || (Identifiers.WorkflowIdentifierEnum = {}));
    var TaxonomyIdentifierEnum;
    (function (TaxonomyIdentifierEnum) {
        TaxonomyIdentifierEnum["InternalId"] = "internalId";
        TaxonomyIdentifierEnum["ExternalId"] = "externalId";
        TaxonomyIdentifierEnum["Codename"] = "codename";
    })(TaxonomyIdentifierEnum = Identifiers.TaxonomyIdentifierEnum || (Identifiers.TaxonomyIdentifierEnum = {}));
    var AssetIdentifierEnum;
    (function (AssetIdentifierEnum) {
        AssetIdentifierEnum["InternalId"] = "internalId";
        AssetIdentifierEnum["ExternalId"] = "externalId";
    })(AssetIdentifierEnum = Identifiers.AssetIdentifierEnum || (Identifiers.AssetIdentifierEnum = {}));
    var WebhookIdentifierEnum;
    (function (WebhookIdentifierEnum) {
        WebhookIdentifierEnum["Id"] = "id";
    })(WebhookIdentifierEnum = Identifiers.WebhookIdentifierEnum || (Identifiers.WebhookIdentifierEnum = {}));
    var AssetIdentifier = /** @class */ (function () {
        function AssetIdentifier(identifier, value) {
            this.identifier = identifier;
            this.value = value;
        }
        AssetIdentifier.prototype.getParamValue = function () {
            if (this.identifier === AssetIdentifierEnum.InternalId) {
                return "" + this.value;
            }
            if (this.identifier === AssetIdentifierEnum.ExternalId) {
                return "external-id/" + this.value;
            }
            throw Error("Unsupported identifier '" + this.identifier + "'");
        };
        return AssetIdentifier;
    }());
    Identifiers.AssetIdentifier = AssetIdentifier;
    var TaxonomyIdentifier = /** @class */ (function () {
        function TaxonomyIdentifier(identifier, value) {
            this.identifier = identifier;
            this.value = value;
        }
        TaxonomyIdentifier.prototype.getParamValue = function () {
            if (this.identifier === TaxonomyIdentifierEnum.InternalId) {
                return "" + this.value;
            }
            if (this.identifier === TaxonomyIdentifierEnum.ExternalId) {
                return "external-id/" + this.value;
            }
            if (this.identifier === TaxonomyIdentifierEnum.Codename) {
                return "codename/" + this.value;
            }
            throw Error("Unsupported identifier '" + this.identifier + "'");
        };
        return TaxonomyIdentifier;
    }());
    Identifiers.TaxonomyIdentifier = TaxonomyIdentifier;
    var ContentTypeIdentifier = /** @class */ (function () {
        function ContentTypeIdentifier(identifier, value) {
            this.identifier = identifier;
            this.value = value;
        }
        ContentTypeIdentifier.prototype.getParamValue = function () {
            if (this.identifier === ContentTypeIdentifierEnum.Codename) {
                return "codename/" + this.value;
            }
            if (this.identifier === ContentTypeIdentifierEnum.InternalId) {
                return "" + this.value;
            }
            if (this.identifier === ContentTypeIdentifierEnum.ExternalId) {
                return "external-id/" + this.value;
            }
            throw Error("Unsupported identifier '" + this.identifier + "'");
        };
        return ContentTypeIdentifier;
    }());
    Identifiers.ContentTypeIdentifier = ContentTypeIdentifier;
    var WorkflowIdentifier = /** @class */ (function () {
        function WorkflowIdentifier(identifier, value) {
            this.identifier = identifier;
            this.value = value;
        }
        WorkflowIdentifier.prototype.getParamValue = function () {
            if (this.identifier === WorkflowIdentifierEnum.Id) {
                return "" + this.value;
            }
            if (this.identifier === WorkflowIdentifierEnum.Codename) {
                return "codename/" + this.value;
            }
            throw Error("Unsupported identifier '" + this.identifier + "'");
        };
        return WorkflowIdentifier;
    }());
    Identifiers.WorkflowIdentifier = WorkflowIdentifier;
    var ContentItemIdentifier = /** @class */ (function () {
        function ContentItemIdentifier(identifier, value) {
            this.identifier = identifier;
            this.value = value;
        }
        ContentItemIdentifier.prototype.getParamValue = function () {
            if (this.identifier === ContentItemIdentifierEnum.Codename) {
                return "codename/" + this.value;
            }
            if (this.identifier === ContentItemIdentifierEnum.InternalId) {
                return "" + this.value;
            }
            if (this.identifier === ContentItemIdentifierEnum.ExternalId) {
                return "external-id/" + this.value;
            }
            throw Error("Unsupported identifier '" + this.identifier + "'");
        };
        return ContentItemIdentifier;
    }());
    Identifiers.ContentItemIdentifier = ContentItemIdentifier;
    var LanguageIdentifier = /** @class */ (function () {
        function LanguageIdentifier(identifier, value) {
            this.identifier = identifier;
            this.value = value;
        }
        LanguageIdentifier.prototype.getParamValue = function () {
            if (this.identifier === LanguageIdentifierEnum.Codename) {
                return "codename/" + this.value;
            }
            if (this.identifier === LanguageIdentifierEnum.InternalId) {
                return "" + this.value;
            }
            if (this.identifier === LanguageIdentifierEnum.ExternalId) {
                return "external-id/" + this.value;
            }
            throw Error("Unsupported identifier '" + this.identifier + "'");
        };
        return LanguageIdentifier;
    }());
    Identifiers.LanguageIdentifier = LanguageIdentifier;
    var WebhookIdentifier = /** @class */ (function () {
        function WebhookIdentifier(identifier, value) {
            this.identifier = identifier;
            this.value = value;
        }
        WebhookIdentifier.prototype.getParamValue = function () {
            if (this.identifier === WebhookIdentifierEnum.Id) {
                return "" + this.value;
            }
            throw Error("Unsupported identifier '" + this.identifier + "'");
        };
        return WebhookIdentifier;
    }());
    Identifiers.WebhookIdentifier = WebhookIdentifier;
})(Identifiers = exports.Identifiers || (exports.Identifiers = {}));
//# sourceMappingURL=identifiers.js.map